<template>
    <!-- Top Bar
============================================= -->
    <div id="top-bar">

        <div class="container clearfix">

            <div class="col_half nobottommargin clearfix">

                <!-- Top Social
                ============================================= -->
                <div id="top-social">
                    <ul>
                        <li><a href="https://www.facebook.com/TDAdental" class="si-facebook" target="_blank"><span
                                class="ts-icon"><i class="icon-facebook"></i></span><span
                                class="ts-text">Facebook</span></a></li>
                        <li><a href="https://twitter.com/TDAdental" class="si-twitter" target="_blank"><span
                                class="ts-icon"><i class="icon-twitter"></i></span><span class="ts-text">Twitter</span></a>
                        </li>
                        <li><a href="https://www.linkedin.com/company/total-dental-administrators" class="si-linkedin"
                               target="_blank"><span class="ts-icon"><i class="icon-linkedin"></i></span><span
                                class="ts-text">LinkedIn</span></a></li>
                    </ul>
                </div><!-- #top-social end -->

            </div>

            <div class="col_half fright col_last clearfix nobottommargin">

                <!-- Top Links
                ============================================= -->
                <div class="top-links">
                    <ul>
                        <li>
                            <a href="https://www.tdadental.com/providers/search">
                                Provider Network
                            </a>
                        </li>
                    </ul>
                </div><!-- .top-links end -->

            </div>

        </div>

    </div><!-- #top-bar end -->
</template>

<script>
    export default {
        name: 'SocialBar'
    }
</script>

<style scoped>

</style>
